import * as React from "react";
import { Link, LinkProps } from "react-router";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useModalTools } from "@ui/modals/modalContext";
import { AuthModal } from "@ui/components/auth/authModal";

interface LinkExternalProps extends LinkProps {
	to: string;
}
export const LinkExternal: React.FC<LinkExternalProps> = ({ to, ...props }) =>
	to.startsWith("https://") || to.startsWith("http://") ? (
		<a target="_blank" rel="noreferrer" href={to} {...props} />
	) : (
		<Link to={to} {...props} />
	);

interface AuthLinkProps extends LinkProps {
	to: string;
}
export const AuthLink: React.FC<AuthLinkProps> = ({ to, ...props }) => {
	const currentProfile = useCurrentProfile();
	const { createModal } = useModalTools();

	return (
		<Link
			to={to}
			{...props}
			onClick={(e) => {
				if (!currentProfile) {
					createModal((close) => <AuthModal close={close} />);
					e.preventDefault();
				}
			}}
		/>
	);
};
